import React from 'react'
import SliderHome from '../../atoms/slider-home/slider-home'

import useMediaQuery from '../../../shared/utils/useMediaQuery'
import ShoppingCartFloatButton from '../../atoms/shopping-cart-float-button/shopping-cart-float-button'
import productsOnMobile from '../../../assets/images/banner-home/products-mb-clear.png'
import productsOnMobileChile from '../../../assets/images/banner-home/products-mb-clear-chile.png'
import './banner-home.scss'
import { LOCALE } from '../../../constants/activity-constants'

const ReplicaChile = LOCALE === 'es-CL'

const BannerHome = ({ canBuy = true }) => {
  const isMobile = useMediaQuery()
  const mbText = (default_text, mobile_text) => {
    return isMobile ? mobile_text : default_text
  }
  return (
    <section className={ReplicaChile ? 'f-banner-home-chile' : 'f-banner-home'}>
      <aside className="f-banner-home__aside --left">
        <div className="f-banner-home__slider">
          <div className="f-banner-home__decorative --rombo" />
          <div className="f-banner-home__decorative --rombo" />
          <SliderHome />
        </div>

        <div className="f-banner-home__primary-text">
          <p className="f-banner-home__text --t1">
            {mbText(
              <>
                ¿SABÍAS QUE TU ZONA V SE EXPONE TODOS <br />
                LOS DÍAS A COSAS QUE LA ALTERAN?
              </>,
              <>¿SABÍAS QUE TU ZONA V ESTÁ EXPUESTA A COSAS QUE LA ALTERAN? </>
            )}
          </p>
        </div>
      </aside>
      <aside className="f-banner-home__aside --right">
        <div className="f-banner-home__secondary-text">
          <p className="f-banner-home__text --t2">
            {mbText(
              <>
                ¡LLEGAN LOS PREBIÓTICOS*
                <br />A TU ZONA V PARA PROTEGERLA,
              </>,
              <>
                ¡LLEGAN LOS PREBIÓTICOS*
                <br />
                PARA PROTEGERLA
              </>
            )}
          </p>
          <p className="f-banner-home__text --t4">
            {mbText(
              <>
                manteniendo un pH saludable <br />y en equilibrio
              </>,
              <>
                manteniendo un pH <br /> en equilibrio!
              </>
            )}
          </p>
        </div>
        <div className="f-banner-home__decorative --enriquecido"></div>
        <div className="f-banner-home__decorative --gyn-tested"></div>
      </aside>
      {ReplicaChile ? (
        <div className="f-banner-home-chile__products-onmobile">
          <figure className="f-banner-home-chile__products-onmobile__figure">
            <img
              className="f-banner-home-chile__products-onmobile__image"
              src={productsOnMobileChile}
            />
          </figure>
        </div>
      ) : (
        <div className="f-banner-home__products-onmobile">
          <figure className="f-banner-home__products-onmobile__figure">
            <img
              className="f-banner-home__products-onmobile__image"
              src={productsOnMobile}
            />
          </figure>
        </div>
      )}
      {canBuy && <ShoppingCartFloatButton />}
    </section>
  )
}

export default BannerHome
